export default __webpack_public_path__ + "static/media/avatar-1.2d6d3229.png";